export const lab2LayoutTheme = {
    pagePadding: 24,
    mapHeight: 780,
    mapBoxShadow: '0 15px 40px rgba(15, 23, 42, 0.08)',
    pageBackground: '#f5f7fb',
    panelBackground: '#ffffff',
    panelRadius: 20,
    sidebarWidth: 360,
    contentGap: 24,
};

export const lab2MapControlTheme = {
    zoomBackground: 'rgba(255, 255, 255, 0.4)',
    zoomButtonBackground: '#ffffff',
    zoomButtonColor: '#000000',
    attributionBackground: '#ffffffcc',
    popupBackground: '#ffffff',
    popupBorder: '#cccccc',
};
